/* eslint-disable @typescript-eslint/no-explicit-any */

import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import { router } from './routes';
import { loggingOptions } from './middleware/logging';
import { getDynamicImport, getHashMap, stylesUrl } from './loader';
import VueLogger from 'vuejs3-logger';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { LoggedInUserStore } from '@agyletime/vue-3-common/src/plugins/loggedInUser';
import { FeatureFlowPlugin } from '@agyletime/vue-3-common/src/plugins/featureflow';
import { TooltipPlugin } from '@agyletime/vue-3-common/src/plugins/tooltip';
import { ACLPlugin } from '@agyletime/vue-3-common/src/plugins/acl';
import { TranslationsPlugin } from '@agyletime/vue-3-common/src/plugins/translations';
import { Pendo } from '@agyletime/vue-3-common/src/plugins/pendo';
import { ClickOutsideDirective } from '@agyletime/vue-3-common/src/plugins/clickOutside';
import { startMSW } from '../mocks/browser';
import { BasePathPlugin } from '@agyletime/vue-3-common/src/plugins/basePath';
import './styles/variables.scss';

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-061879}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Agyle_Time}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Agyle_Time}_only_for_{16}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Agyle_Time}_need_to_be_licensed___{Agyle_Time}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_August_2025}____[v3]_[01]_MTc1NTM4NTIwMDAwMA==90d29b2021b34d8e10945fb8a84b5315'
);

// Start msw mock service worker
await startMSW();

const app = createApp(App);

app.use(BasePathPlugin);
app.component(
    'NavBar',
    defineAsyncComponent(async () => {
        // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { NavBar } = await getDynamicImport('vue-3-common.es.js');
        return NavBar;
    })
);

app.component(
    'FilterBar',
    defineAsyncComponent(async () => {
        // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { FilterBarAlmendra } = await getDynamicImport('vue-3-common.es.js');
        return FilterBarAlmendra;
    })
);

app.use(ClickOutsideDirective as any);
app.use(VueLogger, loggingOptions);
app.use(router as any);
app.use(LoggedInUserStore as any);
app.use(FeatureFlowPlugin as any);
app.use(ACLPlugin as any);
app.use(TooltipPlugin);
app.use(TranslationsPlugin({}) as any);
app.use(Pendo(import.meta.env.VITE_PENDO_API_KEY) as any);
app.use(async () => {
    // Import the built css for the cdn examples
    const hashmap = await getHashMap();
    const stylesheet = document.createElement('link');
    stylesheet.setAttribute('rel', 'stylesheet');
    stylesheet.setAttribute('type', 'text/css');
    stylesheet.setAttribute('href', `${stylesUrl}${hashmap['style.css']}`);
    document.head.appendChild(stylesheet);
});

app.mount('#app');
